export default __webpack_public_path__ + "static/media/bb.0f67098e.svg";